import ElectromagneticSwitches from "../classes/ElectromagneticSwitch";
import ElectronicRelay from "../classes/ElectronicRelay";
import PowerSwitches from "../classes/PowerSwitch";
import Restaurateur from "../classes/Restaurateur";

export const electromagneticSwitches = [
  new ElectromagneticSwitches({
    alias: "ansi-interruptor-termomagnético-a",
    svgSrc: "/symbol-assets/InterruptorTermomagneticoSimbolo1.svg",
    label: "",
    rotable: true,
    variants: [
      {
        alias: "ansi-interruptor-termomagnético-a-base",
        diagramSvgSrc: "/symbol-assets/InterruptorTermomagneticoSimbolo1.svg",
        label: "Interruptor Termomagnético",
        selected: true
      },
      {
        alias: "ansi-interruptor-Unidad-Disparo-Electronica",
        diagramSvgSrc: "/symbol-assets/InterruptorBajaTensionUnidadDisparoElectronica.svg",
        label: "Interruptor Baja Tensión Unidad Disparo",
        selected: true
      },
      {
        alias: "ansi-interruptor-termomagnético-a-IEC1",
        diagramSvgSrc: "/symbol-assets/IECInterruptorTermomagneticoSimbolo1.svg",
        label: "IEC Variante 1",
        selected: false
      }
    ]
  }),
  
  new ElectromagneticSwitches({
    alias: "ansi-relevador-de-sobrecarga",
    svgSrc: "/symbol-assets/RelevadorSimbolo1.svg",
    label: "Relevador de protección",
    rotable: true
  }),
  new ElectronicRelay({
    alias: "iec-relevador-de-sobrecarga",
    svgSrc: "/symbol-assets/RelevadorSimbolo2.svg",
    label: "Relevador de protección",
    rotable: true
  }),
  
  new PowerSwitches({
    alias: "interruptor-mtat-a",
    svgSrc: "/symbol-assets/InterruptorMT_ATSimbolo1.svg",
    label: "Interruptor de potencia"
  }),
  new PowerSwitches({
    alias: "interruptor-mtat-b",
    svgSrc: "/symbol-assets/InterruptorMT_ATSimbolo2.svg",
    label: "Interruptor de potencia"
  }),
  
  new ElectromagneticSwitches({
    alias: "relevador-de-carga",
    svgSrc: "/symbol-assets/RelevadorDeCarga.svg",
    label: "Relevador de carga",
    rotable: true
  }),
  new Restaurateur({
    alias: "restaurador",
    svgSrc: "/symbol-assets/Restaurador.svg",
    label: "Restaurador",
    rotable: true
  }),
  new ElectromagneticSwitches({
    alias: "switch",
    svgSrc: "/symbol-assets/Switch.svg",
    label: "Desconectador",
    rotable: true
  })
];
